import { render } from "./_IndexInstrutor.vue?vue&type=template&id=04762cb6&scoped=true"
import script from "./_IndexInstrutor.vue?vue&type=script&lang=ts"
export * from "./_IndexInstrutor.vue?vue&type=script&lang=ts"

import "./_IndexInstrutor.vue?vue&type=style&index=0&id=04762cb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04762cb6"

export default script